/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { useState } from "react";
import api from '../api/index.js'

export const useCertificateViewer = ({ showNotification, onImageOpen }) => {
  const [imageLoading, setImageLoading] = useState({ status: false, id: null })

  const handleCertificateDisplay = async (certificateId) => {
    try {
      setImageLoading({ status: true, id: certificateId })

      const res = await api.get(`/v1/admin/certificates/${certificateId}`)
      const fileUrl = res?.data?.file?.url
      const contentType = res?.data?.file?.content_type

      if (fileUrl && contentType === 'application/pdf') {
        window.open(fileUrl, '_blank', 'noopener,noreferrer')
      } 
      else if ( fileUrl && ['image/jpeg', 'image/png'].includes(contentType)) {
        onImageOpen(fileUrl)
      } 
      else {
        showNotification('Certificate url not found', 'error')
      }
    } 
    catch {
      showNotification('Failed to load certificate', 'error')
    } 
    finally {
      setImageLoading({ status: false, id: null })
    }
  }

  return {
    imageLoading,
    handleCertificateDisplay,
  }
}
